module.exports = __webpack_public_path__ + "img/main-image.ed1783b7.webp";